<ng-container *ngIf="warning$ | async as warning">
  <mat-icon color="accent" [matTooltip]="warning">info_outline</mat-icon>
</ng-container>
